import { render, staticRenderFns } from "./YearsChart.vue?vue&type=template&id=2c16f7be&"
import script from "./YearsChart.vue?vue&type=script&lang=js&"
export * from "./YearsChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports